var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.526,
    height: 50.526,
    viewBox: "0 0 50.526 50.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_518",
    "data-name": "Trac\\xE9 518",
    d: "M38.859,16.1,22.21,32.745,13.141,23.7,9.579,27.263,22.21,39.895l20.21-20.21ZM27.263,2A25.263,25.263,0,1,0,52.526,27.263,25.272,25.272,0,0,0,27.263,2Zm0,45.474a20.21,20.21,0,1,1,20.21-20.21A20.2,20.2,0,0,1,27.263,47.474Z",
    transform: "translate(-2 -2)",
    fill: "#3fce97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/good.146c0c1edae29de0bca3c6e576cefd14.svg";
export { ForwardRef as ReactComponent };